import { useState } from 'react';

import styled from '@emotion/styled';
import { css } from '@emotion/react'

import { Card } from '@mui/material';


import WorkingHours from './index';
import { BasicFlex } from '../../utils/Common';

import { Header } from '../../pages/common';

import { useQuery } from '@tanstack/react-query';
import { getStylists } from '../Stylists/apiService';

// icons
import DomainAddRoundedIcon from '@mui/icons-material/DomainAddRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';

const MainPanel = styled.div`
  display: flex;
`

const SelectionPanel = styled(BasicFlex)`
  border-right: 1px solid ${props => props.theme.colors.border};
  flex-direction: column;
  justify-content: flex-start;
`;

const SelectionItemStyles = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.border};
  width: 100%;
  padding: 2rem 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background-color: ${props => props.theme.colors.lightBg};
  cursor: pointer;

  .text {
    font-size: 1.6rem;
    font-weight: 500;
    /* color: ${props => props.theme.colors.mildText}; */
  }

  &:hover {
    background-color: ${props => props.theme.colors.secondaryFaint};
    & * {
      color: ${props => props.theme.colors.secondary};
    }
  }

  ${props => props.$active && css`
    background-color: ${props.theme.colors.secondaryFaint};
    & * {
      color: ${props.theme.colors.secondary};
    }
  `}
`;

const SelectionDivider = styled(SelectionItemStyles)`
  background-color: transparent;
  padding: 1rem 2rem;
`;

const SelectionHeader = styled.div`
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mildText};
`

const SelectionItem = ({type = "Personal", name, active, onClick}) => {
  return (
    <SelectionItemStyles $active={active} onClick={onClick}>
      {type === "Business" ? <DomainAddRoundedIcon color="icon" /> : <ManageAccountsRoundedIcon color="icon" />}
      <div className='text'>{name}</div>
    </SelectionItemStyles>
  )
}

const EditViewWorkingHours = () => {
  const [selected, setSelected] = useState("default");

  const { data } = useQuery({
    queryKey: ["stylists"],
    queryFn: () => getStylists()
  })
  
  return (
    <div>
      <Header>
        <h2>Business Hours Setup</h2>
      </Header>
      <Card variant='outlined' sx={{maxWidth: "128rem"}}>
        <MainPanel>
          <SelectionPanel>
            <SelectionDivider>
              <SelectionHeader>Business working hours</SelectionHeader>
            </SelectionDivider>
            <SelectionItem name="Business Hours" type="Business" active={selected === "default"} onClick={() => setSelected("default")} />
            <SelectionDivider>
              <SelectionHeader>Stylist working hours</SelectionHeader>
            </SelectionDivider>
            {
              data?.map(stylist => (
                <SelectionItem key={stylist.stylist_id} name={stylist.full_name} type="Personal" active={selected === stylist.stylist_id} onClick={() => setSelected(stylist.stylist_id)} />
              ))
            }
          </SelectionPanel>
          <WorkingHours stylist_id={selected !== "default" ? selected : null} get_public={selected === "default"} />
        </MainPanel>
      </Card>
    </div>
  )
};

export default EditViewWorkingHours;